var desktop_slider_options = {
  dots: true,
  swipeToSlide: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay:false,
  autoplaySpeed:6000,
  pauseOnHover:true,
  speed: 2000,
}

var mobile_slider_options = {
  dots: true,
  swipeToSlide: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay:true,
  autoplaySpeed:5000,
  pauseOnHover:true,
  speed: 2000,
}

function heroBannerPriceBoxFadeIn() {
  $('.PriceBox1').delay(1000).fadeIn(500);  
  $('.PriceBox2').delay(1500).fadeIn(500);  
  $('.PriceBox3').delay(2000).fadeIn(500);  
  $('.PriceBox4').delay(2500).fadeIn(500);  
  $('.PriceBox5').delay(3000).fadeIn(500);
  $('.dots_product').delay(3500).fadeIn(500); 
  $('.slider_content').delay(4000).fadeIn(100);
}

$(document).ready(function() {
  heroBannerPriceBoxFadeIn();

  $('.slick_custom_slider').slick({
    swipeToSlide: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed:500,
    prevArrow: '<div class="slider-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></div>',
    nextArrow: '<div class="slider-next"><i class="fa fa-angle-right" aria-hidden="true"></i></div>',
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          infinite: false,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.custom_banner_slider').slick(desktop_slider_options);
  $('.custom_banner_slider_mobile').slick(mobile_slider_options);

  $('.multiple-items-gallery').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    prevArrow: '<div class="slider-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></div>',
    nextArrow: '<div class="slider-next"><i class="fa fa-angle-right" aria-hidden="true"></i></div>',
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          infinite: false,
          slidesToScroll: 1
        }
      }
    ]
  });

  // Add message to cart page prompting user to update cart

  // On input quantity change
  $('[name="updates[]"]').on('change', function() {
    $(this).next('.cart-update-required-notice').remove();
    $(this).after('<p class="cart-update-required-notice">Please click the "Update Cart" button below to see your changes</p>');
  });

  // For Kover insurance widget
  // Temp hack to get this to work
  const koverObserver = new ResizeObserver( function() {
    let $KoverElement = $('.kover-ra-cart');
    let KoverShadow = $KoverElement[0].shadowRoot;

    if(KoverShadow) {
      let KoverSwitcher = KoverShadow.querySelector('.Switcher-module__input-3YHh');

      $(KoverSwitcher).on('change', function() {
        $KoverElement.next('.kover-cart-update-required-notice').remove();
        $KoverElement.after('<p class="kover-cart-update-required-notice">Please click the "Update Cart" button below to see your changes</p>');
      });

      koverObserver.disconnect();
    }
  });

  koverObserver.observe($('.kover-ra-cart')[0]);
});

// Re-init hero sliders inside customizer for proper previewing
document.addEventListener('shopify:section:load', function(event) {
  if (event.target.classList.value.includes('dynamic-hero-banner')) {
    heroBannerPriceBoxFadeIn();

    $('.custom_banner_slider.slick-initialized').slick('unslick');
    $('.custom_banner_slider:not(.slick-initialized)').slick(desktop_slider_options);
  }
});

document.addEventListener('shopify:block:select', function(event) {
  $('.custom_banner_slider.slick-initialized').slick('slickGoTo', event.target.getAttribute('data-block-index'));
});

$('.custom_banner_slider').on('beforeChange', function() {
  $('.PriceBox2').css('display','none'); 
  $('.PriceBox3').css('display','none');
  $('.PriceBox4').css('display','none');
  $('.PriceBox5').css('display','none');
  $('.desktop_slide_banner .dots_product').css('display','none');
  $('.desktop_slide_banner .slider_content').css('display','none');

  heroBannerPriceBoxFadeIn()
});

$('.custom_banner_slider_mobile').on('beforeChange', function() {
  $('.mobile_slide_banner .dots_product').css('display','none');
  $('.mobile_slide_banner .slider_content').css('display','none');

  $('.mobile_slide_banner .dots_product').delay(500).fadeIn(500); 
  $('.mobile_slide_banner .slider_content').delay(1000).fadeIn(500);
});

// Play/pause video on thumbnail switch
$('.product-thumbnail-images').on('afterChange', function(event, slick, currentSlide) {
  let $productVideos = $('.product-media-video video');
  if ($productVideos.length) $productVideos[0].pause();

  let currentSlideEl = slick.$slides.get(currentSlide);
  if (currentSlideEl.classList.contains('product-thumbnail-media-video')) {
    $(".product-media-video[data-slick-index='" + currentSlide + "']").find('video')[0].play();
  }
});